import React, { useEffect, useState } from 'react';
import '../../Styles/Profile.css';
// import CssClass from "../../Styles/common.module.css";
import 'bootstrap/dist/css/bootstrap.min.css';
// import { c_API_IP } from '../../Common/commonURL.js'; 
import { useCookies } from "react-cookie";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import http from "../../Common/http-common.js";
import * as common from "../../Common/common.js";
import { GetPageAuthorityFn } from "../../Common/authority.js";
import * as Comp from "../../Common/CommonComponents.js";
import ProfileChangePassword from '../../Components/Profile/ProfileChangePassword.js';
import { differenceInYears, differenceInMonths, differenceInDays, format } from 'date-fns';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";

const PAGE_NAME = "Profile.js";
const MODULE_ID = "WEB_URS_001"

const Profile = (props) => {
    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);
    const navigate = useNavigate();

    const [profileData, setProfileData] = useState({});
	const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading...");
    const [reload, setReload] = useState(false);
    const [showProfileResetPassword, setShowProfileResetPassword] = useState(false);
    const [editData, setEditData] = useState([]);

    const [actionAuthority, setActionAuthority] = useState({
        READ: "N",
        WRITE: "N",
        READALL: "N",
    });
    
    
    useEffect(() => {
        let promise = GetPageAuthorityFn(userId, MODULE_ID);
        promise.then(
            (result) => {
            setActionAuthority(result);
            if (result.READ === "N") {
                navigate("/Dashboard");
            }
            },
            (error) => {
            setActionAuthority({
                READ: "N",
                RITE: "N",
                READALL: "N",
            });
            common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
            toast.error(error);
            navigate("/Dashboard");
            }
        );
    }, [userId, navigate]);

    //region get profile list
    useEffect(() => {
        if (actionAuthority.READ === "Y") {
        let functionName = "useEffect Get Profile";
            try {
                setLoading(true);
                setLoadingText("Getting Profile, please wait...");

                setProfileData({
                    USER_ID: '',
                    USERNAME: '',
                    EMAIL: '',
                    ROLE_NAME: '',
                    SERVICE_LENGTH: '',
                    EMPLOYMENT_STATUS: '',
                });

                http
                .get("api/profile/GetProfileById?_userId=" + userId,
                    { timeout: 10000 })
                .then((response) => {
                    const data = response.data;
                    if (data) {
                        const startDateStr = data.SERVICE_STARTDATE;
                        const endDateStr = data.SERVICE_ENDDATE;
                        let timeText = '';
                        let durationText = '';

                        if (startDateStr) {
                            const startDate = new Date(startDateStr);
                            let endDate = new Date();
                        
                            if (endDateStr && new Date(endDateStr) > startDate) {
                                endDate = new Date(endDateStr);
                            }
                        
                            const totalYears = differenceInYears(endDate, startDate);
                            const tempDateAfterYears = new Date(startDate);
                            tempDateAfterYears.setFullYear(tempDateAfterYears.getFullYear() + totalYears);
                        
                            const totalMonths = differenceInMonths(endDate, tempDateAfterYears);
                            const tempDateAfterMonths = new Date(tempDateAfterYears);
                            tempDateAfterMonths.setMonth(tempDateAfterMonths.getMonth() + totalMonths);
                        
                            const totalDays = differenceInDays(endDate, tempDateAfterMonths);
                        
                            const formattedStart = format(startDate, "dd MMM yyyy");
                            const formattedEnd = endDateStr && new Date(endDateStr) > startDate
                              ? format(endDate, "dd MMM yyyy")
                              : "Present";
                        
                            const yearLabel = `${totalYears} year${totalYears !== 1 ? 's' : ''}`;
                            const monthLabel = `${totalMonths} month${totalMonths !== 1 ? 's' : ''}`;
                            const dayLabel = `${totalDays} day${totalDays !== 1 ? 's' : ''}`;
                        
                            timeText = `${yearLabel}, ${monthLabel}, ${dayLabel}`;
                            durationText = `${formattedStart} - ${formattedEnd} (${timeText})`;
                        }

                        setProfileData({
                            USER_ID: data.USER_MST_GUID || '',
                            USERNAME: data.USERNAME || '',
                            EMAIL: data.EMAIL || '',
                            ROLE_NAME: data.ROLE_NAME || '',
                            SERVICE_LENGTH: durationText || '',
                            EMPLOYMENT_STATUS: data.EMPLOYMENT_STATUS || '',
                        });
                    }
                    else {
                        toast.error("No profile data found.")
                    }
                })
                .catch((err) => {
                    toast.error("Error on getting profile. Please try again.");
                    common.c_LogWebError(PAGE_NAME, functionName, err);
                })
                .finally(() => {
                    setLoading(false);
                    setLoadingText("Loading...");
                });
            } catch (err) {
                toast.error("Error on getting profile. Please try again.");
                common.c_LogWebError(PAGE_NAME, functionName, err);
            }
        }
    }, [reload, actionAuthority, userId]);

    //#region Event Handle
    
	const onLoadingHandler = (load, text) => {
        setLoading(load);
        setLoadingText(text);
    };
    
    const onReloadHandler = () => {
        setReload(!reload);
    };

    const showProfileResetPasswordModal = (row) => {
        setShowProfileResetPassword(true);
        setEditData();
    };
    
    const hideProfileResetPasswordModal = () => {
        setShowProfileResetPassword(false);
        setEditData(null);
    };
    //#endregion

    return (
        <>
        <div style={{ padding: "1rem 1rem 0 2rem" }}>
            <table className="profileTable">
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%", fontWeight: 'bold' }}>Name</td>
                    <td style={{ verticalAlign: "middle", width: "5%", fontWeight: 'bold' }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%", fontWeight: 'bold' }}>
                        {profileData.USERNAME || 'N/A'}
                    </td>
                </tr>
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%", fontWeight: 'bold' }}>Email Address</td>
                    <td style={{ verticalAlign: "middle", width: "5%", fontWeight: 'bold' }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%", fontWeight: 'bold' }}>
                        {profileData.EMAIL || 'N/A'}
                    </td>
                </tr>
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%", fontWeight: 'bold' }}>Password</td>
                    <td style={{ verticalAlign: "middle", width: "5%", fontWeight: 'bold' }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%", fontWeight: 'bold' }}>
                        <button 
                            className="profile-reset-button"
                            id= "btnProfileResetPassword"
                            type="reset"
                            style={{background: '#663399'}} //#663399 //#FFA500
                            onClick= {() => showProfileResetPasswordModal()}
                        >
                            <FontAwesomeIcon icon={faKey} />&nbsp; CHANGE PASSWORD
                        </button>
                    </td>
                </tr>
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%", fontWeight: 'bold' }}>Role</td>
                    <td style={{ verticalAlign: "middle", width: "5%", fontWeight: 'bold' }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%", fontWeight: 'bold' }}>
                        {profileData.ROLE_NAME || 'N/A'}
                    </td>
                </tr>
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%", fontWeight: 'bold' }}>Service Length</td>
                    <td style={{ verticalAlign: "middle", width: "5%", fontWeight: 'bold' }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%", fontWeight: 'bold' }}>
                        {profileData.SERVICE_LENGTH || 'N/A'}
                    </td>
                </tr>
                <tr>
                    <td style={{ verticalAlign: "middle", width: "10%", fontWeight: 'bold' }}>Work Status</td>
                    <td style={{ verticalAlign: "middle", width: "5%", fontWeight: 'bold' }}>:</td>
                    <td style={{ verticalAlign: "middle", width: "35%", fontWeight: 'bold' }}>
                        {profileData.EMPLOYMENT_STATUS || 'N/A'}
                    </td>
                </tr>
            </table>
        </div>

        <ProfileChangePassword
            page={PAGE_NAME}
            module={MODULE_ID}
            showHide={showProfileResetPassword}
            editData={profileData}
            onHide={hideProfileResetPasswordModal}
            onLoading={onLoadingHandler}
            onReload={onReloadHandler}
        />

        {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
        <Comp.AlertPopup />
        </>
    );
};

export default Profile;
